import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  AnalyzeCsvRequest,
  AnalyzeCsvResponse,
  ImportBuyerContext,
} from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type AnalyzeBuyersCsvParams = AnalyzeCsvRequest<ImportBuyerContext>;

export const analyzeBuyersCsv = async (
  params: AnalyzeBuyersCsvParams
): Promise<AnalyzeCsvResponse> => {
  return await tinctApi.buyers.analyzeCsv(params);
};

export const useAnalyzeBuyersCsv = (
  options?: Omit<
    UseMutationOptions<AnalyzeCsvResponse, ApiError, AnalyzeBuyersCsvParams>,
    'mutationFn'
  >
) =>
  useMutation({
    mutationFn: analyzeBuyersCsv,
    ...options,
  });
